import "./TabReports.scss";
import React, { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Radio,
  Select,
  Icon,
  Checkbox,
  DatePicker,
  Button
} from "antd";

import { useTranslation } from "react-i18next";
import moment from "moment";
import { getUsersByClientPromise } from "../../../../promises";
import { getGruposPromise } from "../../../Register/promises";
import {getRulesPromise} from '../../promises';
import { globalContext } from '../../../../contexts'

const TabReports = ({ categories }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [obj, setObj] = useState({
    reporte: "alertas",
    tipoAlertas: "automaticas",
    asignadas: false
  });
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rules, setRules] = useState([])
  const { generateReport } = useContext(globalContext)

  useEffect(() => {
    getUsersByClientPromise().then((response) => {
      const filtered = [];
      response.map((u) => {
        if (u.status === "ACTIVE") {
          filtered.push(u);
        }
        return true;
      });
      filtered.sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" }));
      setUsers(filtered);
    });
    getGruposPromise(activeCategory === null ? 'ALL' : activeCategory).then((response) => {
      const filtered = [];
      response.map((g) => {
        if (g.grupo !== "N/A") {
          filtered.push(g.grupo);
        }
        return true;
      });
      filtered.sort((a, b) => (a || "").localeCompare(b || "", undefined, { sensitivity: "base" }));
      setGrupos(filtered);
    });

    getRulesPromise({}).then((response) => {
      const sorted = [...(response.data || [])].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" })
      );
      setRules(sorted)
    })

  }, []);

  const localGenerateReport = (type) => {
    let filters = { ...obj }
    if (filters.assignedUser) {
      const user = users.find((u) => u.id === filters.assignedUser)
      if (user) filters.assignedUserLabel = user.name
    }
    if (filters.userAlertCreation) {
      const user = users.find((u) => u.id === filters.userAlertCreation)
      if (user) filters.userAlertCreationLabel = user.name
    }
    return generateReport(type, filters, finishReport)
  }

  const finishReport = (type) => {
    if(type === 'ALERT' || type === undefined) setIsLoading(false)
  }

  const handleClear = () => {
    let reporte = obj.reporte
    setActiveCategory(null)
    setObj({
      reporte,
      tipoAlertas: "automaticas",
      asignadas: false
    })
  };

  const handleSetActiveCategory = (category) => {
    setActiveCategory(category);
    setObj(prev => {
      const next = { ...prev }
      if (category == null) {
        delete next.category
      } else {
        next.category = category
      }
      return next
    });
  };

  const handleChangeObj = (field, value) => {
    setObj(prev => {
      const next = { ...prev }
      if (value === null || value === undefined) {
        delete next[field]
      } else {
        next[field] = value
      }
      return next
    });
  };

  const handleDownloadReport = async () => {
    localGenerateReport('ALERT').then(r => {
      if(r) {
        setIsLoading(true);
      }
    })
  }

  const filteredRules = rules.filter(rule => {
    if (obj.tipoRiesgo !== undefined)
      return (rule.type === obj.tipoRiesgo)
    else
      return true
  })

  return (
    <div id="tab-reports" className="tab-reports">
      <div className="content-alerts-people">
        <Row>
          <div className="inner-row">
            <Col span={12}>
              <div className="inner-col-header">
                <Radio
                  value="alertas"
                  checked={obj.reporte === "alertas"}
                  onClick={() => setObj({ ...obj, reporte: "alertas" })}
                >
                  {t('messages.aml.monitor.report.alerts')}
                </Radio>
              </div>
            </Col>
            <Col span={12}>
              <div className="inner-col-header">
                <Radio
                  value="personas"
                  checked={obj.reporte === "personas"}
                  onClick={() => setObj({ ...obj, reporte: "personas" })}
                >
                  {t('messages.aml.monitor.report.people')}
                </Radio>
              </div>
            </Col>
          </div>
        </Row>

        <div className="box-inner">
          <Row>
            <div className="inner-row" style={{ marginTop:0 }}>
              <Col span={12} style = {{paddingRight:'5px'}}>
                  <Select
                    style={{ width: '100%' }}
                    value={activeCategory}
                    allowClear
                    onChange={(value) => handleSetActiveCategory(value == null ? null : value)}
                  >
                    <Select.Option value={null}>{t('messages.aml.monitor.report.all')}</Select.Option>
                    {categories.map((category) => (
                      <Select.Option key={category} value={category}>
                        {t("messages.aml.category." + category)}
                      </Select.Option>
                    ))}
                  </Select>
              </Col>

            </div>
          </Row>

          {obj.reporte === "alertas" && (
            <Row>
              <div className="inner-row" style={{ marginTop:0 }}>
                <Col span={12} style = {{paddingRight:'5px'}}>
                  <Select
                    defaultValue="automaticas"
                    style={{ width: "100%" }}
                    value={obj.tipoAlertas}
                    onChange={(value) => handleChangeObj("tipoAlertas", value)}
                  >
                    <Select.Option value="automaticas">
                      {t('messages.aml.monitor.report.alerts.auto')}
                    </Select.Option>
                    <Select.Option value="coincidencias">
                      {t('messages.aml.monitor.report.alerts.name.match')}
                    </Select.Option>
                    <Select.Option value="todos">
                      {t('messages.aml.monitor.report.alerts.all')}
                    </Select.Option>
                  </Select>
                </Col>
                <Col span={3}>
                  <div className="asignadas">{t('messages.aml.monitor.report.assigned')}</div>
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={obj.asignadas}
                    onChange={(e) => {
                      handleChangeObj("asignadas", e.target.checked);
                    }}
                  />
                </Col>
                <Col span={3}>
                  {t('messages.aml.cdi.advanced.clearFilters')}
                </Col>
                <Col span={2}>
                  <Button
                    className="delete-filters"
                    onClick={handleClear}
                  >
                    <Icon type="delete"></Icon>

                  </Button>
                </Col>

              </div>
            </Row>
          )}

          {obj.reporte === "personas" && (
            <Row>
              <div className="inner-row">
                <Col span={18}>
                  {t('messages.aml.monitor.report.people.monitoring')}
                  <hr style={{ marginBlockEnd: '2px' }} />
                </Col>
                <Col span={3} offset={1}>
                  {t('messages.aml.cdi.advanced.clearFilters')}
                </Col>
                <Col span={2}>
                  <Button
                    className="delete-filters"
                    onClick={handleClear}
                  >
                    <Icon type="delete"></Icon>

                  </Button>
                </Col>


              </div>
            </Row>
          )}

          {obj.reporte === "alertas" && (
            <>
              <Row>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">
                      {obj.tipoAlertas === "automaticas" ? t('messages.aml.monitor.report.period.reception') : t('messages.aml.monitor.report.period.created')}
                    </div>
                    <DatePicker.RangePicker
                      placeholder={[t('messages.aml.monitor.report.from'), t('messages.aml.monitor.report.to')]}
                      style={{ width: "100%" }}
                      allowClear
                      value={
                        obj.fechaAlerta
                          ? [
                            moment(obj.fechaAlerta[0]),
                            moment(obj.fechaAlerta[1]),
                          ]
                          : null
                      }
                      onChange={(momentObj) =>
                        handleChangeObj(
                          "fechaAlerta",
                          momentObj !== null && momentObj.length === 2
                            ? [
                              moment(momentObj[0]).valueOf(),
                              moment(momentObj[1]).valueOf(),
                            ]
                            : null
                        )
                      }
                    />
                  </div>
                </Col>

                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.riskType')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("tipoRiesgo", value)}
                      value={obj.tipoRiesgo}
                    >
                      <Select.Option value="DEMOGRAFICA">{t('messages.aml.monitor.alertas.DEMOGRAFICA')}</Select.Option>
                      {obj.tipoAlertas === "automaticas" &&
                        <Select.Option value="TRANSACCIONAL">{t('messages.aml.monitor.alertas.TRANSACCIONAL')}</Select.Option>
                      }
                      {obj.tipoAlertas === "automaticas" &&
                        <Select.Option value="PERSONA">{t('messages.aml.monitor.alertas.PERSONA')}</Select.Option>
                      }
                      {obj.tipoAlertas === "personalizadas" &&
                        <Select.Option value="EVENTO">{t('messages.aml.monitor.report.compliance')}</Select.Option>
                      }
                    </Select>
                  </div>
                </Col>
              
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.score')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("puntaje", value)}
                      value={obj.puntaje}
                    >
                      <Select.Option value={1}>1</Select.Option>
                      <Select.Option value={2}>2</Select.Option>
                      <Select.Option value={3}>3</Select.Option>
                      <Select.Option value={4}>4</Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.alert.status')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("estado", value)}
                      value={obj.estado}
                    >
                      <Select.Option value="OPEN">
                        {t("messages.aml.alert.status.OPEN")}
                      </Select.Option>
                      <Select.Option value="CLOSED">
                        {t("messages.aml.alert.status.CLOSED")}
                      </Select.Option>
                    </Select>
                  </div>
                </Col>

                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.person.type')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) =>
                        handleChangeObj("tipoPersona", value)
                      }
                      value={obj.tipoPersona}

                    >
                      <Select.Option value="Person">{t('messages.aml.monitor.report.natural')}</Select.Option>
                      <Select.Option value="Entity">{t('messages.aml.monitor.report.legal')}</Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.task.status')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("edoTarea", value)}
                      value={obj.edoTarea}
                    >
                      <Select.Option value="COMPLETAS">{t('messages.aml.monitor.report.task.complete')}</Select.Option>
                      <Select.Option value="INCOMPLETAS">
                        {t('messages.aml.monitor.report.task.incomplete')}
                      </Select.Option>
                      <Select.Option value="NoAsignadas">
                        {t('messages.aml.monitor.report.task.unassigned')}
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.rule')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) =>
                        handleChangeObj("ruleId", value)
                      }
                      value={obj.ruleId}
                    >
                      {filteredRules.map(filteredRule => {
                        return  <Select.Option key={filteredRule.id} value={filteredRule.id}>{filteredRule.name}</Select.Option>
                      })}
                    </Select>
                  </div>
                </Col>

                {obj.tipoAlertas === "personalizadas" &&
                  <Col span={12}>
                    <div className="col-inner">
                      <div className="key">{t('messages.aml.monitor.report.user.created')}</div>
                      <Select
                        style={{ width: "100%" }}
                        allowClear
                        onChange={(value) =>
                          handleChangeObj("userAlertCreation", value)
                        }
                        value={obj.userAlertCreation}
                      >
                        {users.map((user) => (
                          <Select.Option key={user.id} value={user.id}>
                            {user.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>
                }
              </Row>


              {obj.asignadas && (
                <Row>
                  <Col span={12}>
                    <div className="col-inner">
                      <div className="key">{t('messages.aml.monitor.report.user.assigned')}</div>
                      <Select
                        style={{ width: "100%" }}
                        allowClear
                        onChange={(value) =>
                          handleChangeObj("assignedUser", value)
                        }
                        value={obj.assignedUser}
                      >
                        {users.map((user) => (
                          <Select.Option key={user.id} value={user.id}>
                            {user.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="col-inner">
                      <div className="key">{t('messages.aml.monitor.report.period.assigned')}</div>
                      <DatePicker.RangePicker
                        placeholder={[t('messages.aml.monitor.report.from'), t('messages.aml.monitor.report.to')]}
                        style={{ width: "100%" }}
                        allowClear
                        value={
                          obj.fechaAsignacion
                            ? [
                              moment(obj.fechaAsignacion[0]),
                              moment(obj.fechaAsignacion[1]),
                            ]
                            : null
                        }
                        onChange={(momentObj) =>
                          handleChangeObj(
                            "fechaAsignacion",
                            momentObj !== null && momentObj.length === 2
                              ? [
                                moment(momentObj[0]).valueOf(),
                                moment(momentObj[1]).valueOf(),
                              ]
                              : null
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
              )}

            </>
          )}

          {obj.reporte === "personas" && (
            <>
              <Row>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.group')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("grupo", value)}
                      value={obj.grupo}
                    >
                      {grupos.map((grupo) => (
                        <Select.Option key={grupo} value={grupo}>{grupo}</Select.Option>
                      ))}
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.monitor.report.person.type')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) =>
                        handleChangeObj("tipoPersona", value)
                      }
                      value={obj.tipoPersona}
                    >
                      <Select.Option value="Person">{t('messages.aml.monitor.report.natural')}</Select.Option>
                      <Select.Option value="Entity">{t('messages.aml.monitor.report.legal')}</Select.Option>
                    </Select>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.riskType')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) =>
                        handleChangeObj("tipoRiesgo", value)
                      }
                      value={obj.tipoRiesgo}
                    >
                      <Select.Option value="DEMOGRAFICA">
                        {t('messages.aml.monitor.alertas.DEMOGRAFICA')}
                      </Select.Option>
                      <Select.Option value="TRANSACCIONAL">
                        {t('messages.aml.monitor.alertas.TRANSACCIONAL')}
                      </Select.Option>
                      <Select.Option value="PERSONA">{t('messages.aml.monitor.alertas.PERSONA')}</Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="col-inner">
                    <div className="key">{t('messages.aml.score')}</div>
                    <Select
                      style={{ width: "100%" }}
                      allowClear
                      onChange={(value) => handleChangeObj("puntaje", value)}
                      value={obj.puntaje}
                    >
                      <Select.Option value={1}>1</Select.Option>
                      <Select.Option value={2}>2</Select.Option>
                      <Select.Option value={3}>3</Select.Option>
                      <Select.Option value={4}>4</Select.Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </>
          )}



          <Button
            icon={isLoading ? "loading" : "file-excel"}
            className="bottom-button"
            type="primary"
            disabled={isLoading}
            onClick={handleDownloadReport}
          >
            {t('messages.aml.monitor.report.export.excel')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default TabReports;
